module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tabbar', {
    staticClass: "footFix"
  }, _vm._l((_vm.footerList), function(item) {
    return _c('tabbar-item', {
      key: item.name,
      class: {
        selected: _vm.getRealPath(item).status
      },
      attrs: {
        "link": item.link
      }
    }, [_c('img', {
      attrs: {
        "slot": "icon",
        "src": _vm.getRealPath(item).url
      },
      slot: "icon"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "slot": "icon-active",
        "src": _vm.getRealPath(item).url
      },
      slot: "icon-active"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(item.text))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fd1c4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/Footer.vue
// module id = HprG
// module chunks = 1